import axios from "axios";
import { Message } from "element-ui";
import { getBaseUrl,setBaseUrl} from "@/config";

// 创建axios实例
const instance = axios.create({
  baseURL: '/api', // 默认值，请求拦截器会动态覆盖
  timeout: 1000 * 60,
});

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 动态设置 baseURL
    const dynamicBaseUrl = getBaseUrl()
    if (dynamicBaseUrl) {
      config.baseURL = dynamicBaseUrl
    }else{
      config.baseURL = 'http://isefdpdf.iagr.cn'
    }
    setBaseUrl(config.baseURL)
    config.headers['token'] = window.sessionStorage.getItem('token');
    return config;
  },
  function (error) {
    Message.error({ message: "请求超时!" });
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    console.log("response====", response);
    if (response.data.code === 200) {
      return response.data;
    } else if (response.data.code === 301) {
      Message.error({ message: "请先登录!" });
      return Promise.reject("请先登录!");
    } else {
      Message.error({ message: response.data.msg });
      return Promise.reject(response.data.msg);
    }
  },
  function (error) {
    let errorMsg = "系统错误";
    if (error.response && error.response.data) {
      errorMsg = error.response.data.msg || error.response.data.message || "系统错误";
    } else if (error.message) {
      errorMsg = error.message;
    }
    Message.error({
      message: errorMsg,
      duration: 3000,
    });
    return Promise.reject(error);
  }
);

export default instance;
